import './polyfills/resizeObserverPolyfill'
import { registerApplication, start } from 'single-spa'
import FetchIntercept from './refactory/kernel/fetch-intercept'
import i18n from './config/i18n'

FetchIntercept(i18n)

registerApplication(
  'root',
  () => import('./root.app'),
  () => true
)

start()
